var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,23.5L9.9,23.5c0.1,0.1,1.5,1.1,3.4,1.4c0.4,0.1,1,0.1,1.7,0.1c1.7,0,4.1-0.3,6-1.9 c1.6-1.3,2.5-3.3,2.7-5.9l0,0V11c0-1.5-1.2-2.6-2.6-2.6c-0.5,0-1,0.2-1.5,0.5c-0.2-1.2-1.3-2.1-2.5-2.1c-0.8,0-1.5,0.4-1.9,0.9 c-0.5-0.6-1.2-0.9-2-0.9c-0.5,0-1,0.2-1.4,0.4V2.7c0-1.5-1.1-2.7-2.5-2.7C7.9,0,6.7,1.2,6.7,2.7v10.5l-0.9-0.7 C5.3,12,4.7,11.8,4,11.8s-1.4,0.3-1.9,0.8s-0.8,1.2-0.8,1.9s0.3,1.4,0.8,1.9L9.9,23.5z M3.1,13.5c0.5-0.5,1.3-0.5,1.8,0 c0,0,0,0,0.1,0.1l2,1.5c0.2,0.2,0.5,0.2,0.7,0.1c0.2-0.1,0.4-0.4,0.4-0.6V2.7c0-0.7,0.5-1.4,1.2-1.4s1.2,0.7,1.2,1.4v6.8v2.7v0.3 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-0.3V9.5c0-0.7,0.7-1.4,1.4-1.4s1.3,0.7,1.3,1.4v3.2c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 V9.4c0-0.7,0.5-1.3,1.2-1.3s1.2,0.6,1.2,1.3v1.8v1v0.5c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-0.5v-1c0-0.7,0.7-1.4,1.4-1.4 c0.7,0,1.3,0.6,1.3,1.3v6.1c-0.1,2.2-0.9,3.8-2.2,4.9c-2.2,1.8-5.4,1.6-6.6,1.5c-1.4-0.2-2.5-0.9-2.7-1.1l-7.7-7.1 c-0.2-0.2-0.4-0.6-0.4-0.9S2.8,13.8,3.1,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.cbdf37805bf98e46c012950c2256ec8d.svg";
export { ForwardRef as ReactComponent };